module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_L-8149.41961778.png";